import { render } from "./FooterLogo.vue?vue&type=template&id=86dbd4cc&scoped=true&ts=true"
import script from "./FooterLogo.vue?vue&type=script&lang=ts"
export * from "./FooterLogo.vue?vue&type=script&lang=ts"

import "./FooterLogo.vue?vue&type=style&index=0&id=86dbd4cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86dbd4cc"]])

export default __exports__